import generify from './generic'

export const tags = generify('experiences-service', 'tags', 'tag')

tags.getFromExperience = (experienceUid, showDeleted) => {
  return tags.getFrom('experiences', experienceUid, showDeleted)
}
